module.exports = __webpack_public_path__ + "img/shop_lack.05137871.png";